import { useContext } from "react";
// import { FormContextMA } from "../form-context";
import {
  Section,
  H2,
  P,
  DataField,
  H3,
  TealSubSection,
} from "./common-components";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const ClassificationofMinorAilment = ({clinicalServiceName, treatment, formType }) => {
  // const { clinicalServiceName, treatment, formType } = useContext(FormContextMA);

  const minorAilmentName = { allergicRhinitis: "Allergic Rhinitis" }[
    clinicalServiceName
  ];

  let classificationOfMinorAilment = {
    classification: "None",
    description: "None",
  };

  if (
    treatment?.frequencyOfSymptoms === "lessThanFourWeeks" &&
    treatment?.levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    classificationOfMinorAilment = {
      classification: "Mild Intermittent",
      description: (
        <>
          Symptoms less than 4 days per week OR less than 4 consecutive weeks.
          <br />
          Symptoms DO NOT interfere with daily activities (work, school, sport,
          leisure).
          <br />
          Symptoms are not bothersome and have LITTLE to NO effect on sleep.
        </>
      ),
    };
  } else if (
    treatment?.frequencyOfSymptoms === "moreThanFourWeeks" &&
    treatment?.levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    classificationOfMinorAilment = {
      classification: "Mild Persistent",
      description: (
        <>
          Symptoms on 4 or more days per week AND more than 4 consecutive weeks.
          <br />
          Symptoms DO NOT interfere with daily activities (work, school, sport,
          leisure).
          <br />
          Symptoms are not bothersome and have LITTLE to NO effect on sleep.
        </>
      ),
    };
  } else if (
    treatment?.frequencyOfSymptoms === "lessThanFourWeeks" &&
    treatment?.levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    classificationOfMinorAilment = {
      classification: "Moderate to Severe Intermittent",
      description: (
        <>
          Symptoms less than 4 days per week OR less than 4 consecutive weeks.
          <br />
          Symptoms interfere significantly in performance of normal daily
          activities.
          <br />
          Symptoms are bothersome and DISTURB sleep.
        </>
      ),
    };
  } else if (
    treatment?.frequencyOfSymptoms === "moreThanFourWeeks" &&
    treatment?.levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    classificationOfMinorAilment = {
      classification: "Moderate to Severe Persistent",
      description: (
        <>
          Symptoms on 4 or more days per week AND more than 4 consecutive weeks.
          <br />
          Symptoms interfere significantly in performance of normal daily
          activities.
          <br />
          Symptoms are bothersome and DISTURB sleep.
        </>
      ),
    };
  }

  return (
    <Section formType={formType}>
      <H2>{`Classification of Minor Ailment - ${minorAilmentName}`}</H2>
      {[AllergicRhinitisDocTypes.InitialAssessment].includes(formType) ? (
        <>
          <H3>{`Symptom Duration/ Frequency/ Level of Severity`}</H3>
          {classificationOfMinorAilment.classification === "None" ? (
            "None"
          ) : (
            <>
              <TealSubSection className="space-y-2 !mt-2">
                <DataField
                  value={`My Results: ${classificationOfMinorAilment.classification}`}
                />
              </TealSubSection>
              <p className="text-xs">
                {classificationOfMinorAilment.description}
              </p>
            </>
          )}
        </>
      ) : (
        <>
          <DataField label={`Symptom Duration/ Frequency/ Level of Severity`} />
          {classificationOfMinorAilment.classification === "None" ? (
            "None"
          ) : (
            <>
              <DataField
                value={`My Results: ${classificationOfMinorAilment.classification}`}
              />
              <p className="text-xs">
                {classificationOfMinorAilment.description}
              </p>
            </>
          )}
        </>
      )}
    </Section>
  );
};
